<template>
    <slot
        v-if="error"
        name="error"
        :error="error"
    >
        <BaseSuspenseAlerts :error="error" />
    </slot>
    <Suspense v-else>
        <template #default>
            <slot name="default" />
        </template>
        <template #fallback>
            <slot name="fallback" />
        </template>
    </Suspense>
</template>

<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue';
import BaseSuspenseAlerts from './BaseSuspenseAlerts.vue';

const error = ref(null);
onErrorCaptured((err: Error) => (error.value = err));
</script>
